import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PremiumFeatureDialogService } from 'src/app/core/premium-feature-dialog.service';
import { UserService } from 'src/app/core/user.service';
import { Course } from 'src/app/models/course.model';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-smart-repetition-list',
  templateUrl: './smart-repetition-list.component.html',
  styleUrls: ['./smart-repetition-list.component.scss'],
  standalone: false
})
export class SmartRepetitionListComponent {
  
  @Input() courses: Course[] = [];

  user?: User;

  learnOptionsList: any = [
    {
      icon: 'cards',
      text: 'Klassischer Modus',
      action: 'classic-mode',
      style: 'neutral'
    },
    {
      icon: 'forms',
      text: 'Texteingabe-Modus',
      action: 'text-answer-mode',
      style: 'neutral'
    },
    {
      icon: 'microphone',
      text: 'Audio-Modus',
      action: 'audio-mode',
      style: 'neutral'
    }
  ];
  showLearnOptions: boolean = false;
  clickedType: 'course' | 'learnset' | null = null;
  clickedId: number | null = null;

  constructor(
    private router: Router,
    private userService: UserService,
    private premiumFeatureDialogService: PremiumFeatureDialogService
  ) { }

  ngOnInit() {
    this.userService.getUser().subscribe(user => {
      this.user = user;
    });
  }

  handleLearnCourseClick(courseId: number) {
    this.clickedType = 'course';
    this.clickedId = courseId;
    this.showLearnOptions = !this.showLearnOptions;
  }

  handleLearnsetClick(learnsetId: number) {
    this.router.navigate([`/sets/${learnsetId}`]);
  }

  handleLearnLearnsetClick(learnsetId: number) {
    this.clickedType = 'learnset';
    this.clickedId = learnsetId;
    this.showLearnOptions = !this.showLearnOptions;
  }

  handleLearnOptionClick(action: string) {
    if (action === 'classic-mode') {
      this.navigateToLearn(action);
    } else if (action === 'text-answer-mode') {
      this.handleTextAnswerModeClicked(action);
    } else if (action === 'audio-mode') {
      this.handleAudioModeClicked(action);
    }
  }

  navigateToLearn(action: string) {
    if (this.clickedType === 'learnset') {
      this.router.navigate([`/sets/${this.clickedId}/learn/${action}`], { queryParams: { smartRepetition: true } });
    } else {
      this.router.navigate([`/sets/${this.courses.find((course) => course.id == this.clickedId)?.learnsets[0].id}/learn/${action}`]);
    }
  }

  handleTextAnswerModeClicked(action: string) {
    if (this.user && this.user.isPremiumUser) {
      this.navigateToLearn(action);
    } else {
      this.premiumFeatureDialogService.showDialog('Texteingabe-Modus', 'So funktioniert es: du wiederholst deine Karten, indem du die jeweilige Antwort eintippst. Die Sparkly-KI gibt dir direktes Feedback und stuft basierend darauf automatisch ein, wann die Lernkarte das nächste Mal wiederholt werden sollte.');
    }
  }

  handleAudioModeClicked(action: string) {
    if (this.user && this.user.isPremiumUser) {
      this.navigateToLearn(action);
    } else {
      this.premiumFeatureDialogService.showDialog('Audio-Modus', 'So funktioniert es: die KI liest dir die Vorderseite der Karte vor und du antwortest per Spracheingabe. Die Sparkly-KI gibt dir direktes Feedback und stuft basierend darauf automatisch ein, wann die Lernkarte das nächste Mal wiederholt werden sollte.');
    }
  }
}
